









import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { IDocumentImageSource } from "../../../domain/document";
import { ModelEditableMixin } from "../../system/mixins";
import { FileToBase64TextConverter } from "./FileToBase64TextConverter";

@Component({
})
export default class ImageFileUploader extends Mixins(ModelEditableMixin) {
  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  handleFileChanged(e: Event): void {
    const target = e.target as HTMLInputElement;
    if (target.files.length < 1) {
      return;
    }
    const file = target.files[0];
    if (!file || file.type.indexOf("image/") !== 0) {
      return;
    }
    FileToBase64TextConverter.convert(
      file,
      this.uploadImageFile,
      () => {
        this.$error(
          "画像変換失敗",
          "画像の変換に失敗しました。"
        );
    });
  }

  createDocumentImageSource(imageText: string): Promise<IDocumentImageSource> {
    return this.createImageSource
      ? this.createImageSource(imageText)
      : DomainRegistry.document.getDocumentRepository().createImageSource(imageText);
  }

  private uploadImageFile(imageText: string): void {
    this.createDocumentImageSource(imageText)
    .then(s => {
      this.editingSource = s;
    }).catch(e => {
      this.$error(
        "画像登録失敗",
        "画像の登録に失敗しました。",
        e,
      );
    });
  }
}
